import React from "react";

function HideResultSum() {
  return (
    <div className={``}>
      Your results will be available and shared with you by the assessor later.
    </div>
  );
}

export default HideResultSum;
